module.exports = __webpack_public_path__ + "img/college6.f70f4a03.png";